// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var OrderExecutionType;
(function (OrderExecutionType) {
    // UNKNOWN - внутренний тип для обработки ошибок, сервер его не передает
    OrderExecutionType[OrderExecutionType["UNKNOWN"] = 0] = "UNKNOWN";
    // событие запроса создания ордера в нашей системе
    OrderExecutionType[OrderExecutionType["PENDING_NEW"] = 1] = "PENDING_NEW";
    // событие выполнения условий ордера на исполнение
    OrderExecutionType[OrderExecutionType["PENDING_EXECUTION"] = 2] = "PENDING_EXECUTION";
    // событие запроса отмены ордера
    OrderExecutionType[OrderExecutionType["PENDING_CANCEL"] = 3] = "PENDING_CANCEL";
    // событие запроса на модификацию ордера
    OrderExecutionType[OrderExecutionType["PENDING_REPLACE"] = 4] = "PENDING_REPLACE";
    // модификация неактивного ордера
    OrderExecutionType[OrderExecutionType["PENDING_REPLACE_NOT_ACTIVE"] = 5] = "PENDING_REPLACE_NOT_ACTIVE";
    // событие создания ордера в нашей системе
    OrderExecutionType[OrderExecutionType["NEW"] = 10] = "NEW";
    // событие создания ордера, который неактивен до выполнения некоторых условий
    OrderExecutionType[OrderExecutionType["ACCEPTED"] = 11] = "ACCEPTED";
    // событие модификации ордера
    OrderExecutionType[OrderExecutionType["REPLACED"] = 20] = "REPLACED";
    // событие частичного заполнения ордера
    OrderExecutionType[OrderExecutionType["PART_FILLED"] = 30] = "PART_FILLED";
    // событие полного исполнения ордера
    OrderExecutionType[OrderExecutionType["FILLED"] = 31] = "FILLED";
    // событие отмены ордера
    OrderExecutionType[OrderExecutionType["CANCELED"] = 40] = "CANCELED";
    // событие отклонения ордера
    OrderExecutionType[OrderExecutionType["REFUSED"] = 41] = "REFUSED";
    // событие смены статуса ордера, которое не покрывается описанными событиями
    OrderExecutionType[OrderExecutionType["RESTATED"] = 42] = "RESTATED";
    // событие активации ордера. Пример - достижение стоп прайса стоп-лимит ордера;
    OrderExecutionType[OrderExecutionType["ACTIVATED"] = 43] = "ACTIVATED";
    // удаляем ордер из панелей
    OrderExecutionType[OrderExecutionType["REMOVED"] = 80] = "REMOVED";
})(OrderExecutionType || (OrderExecutionType = {}));
